<template>
  <div>
    <hero-element
      :heroClaim="heroClaim"
      :hasSearchField="true"
      :hasMobileFilter="false"
    ></hero-element>

    <v-main id="main-content" class="content-area">
      <v-container>
        <v-row>
          <v-col cols="12">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <component :is="Component" />
              </transition>
            </router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import heroElement from '@/components/hero-element.vue';

export default {
  props: {
    heroClaim: {
      type: String,
      required: true
    }
  },

  components: {
    heroElement
  }
};
</script>
